import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { Fragment, useState } from "react";
import convertCurrency, { convertIntMoney } from "src/helper/convertCurrency";
import useInventoryNoteDetail from "src/hooks/inventory/useInventoryNoteDetail";

export default function PayTheDebtDialog({ item, wHouseId }) {
  const [debtDetail, setDebtDetail] = useState();
  const { data: inventDetail, isLoading } = useInventoryNoteDetail(item?._id, {
    warehouse: wHouseId,
  });

  return (
    <Fragment>
      <DialogContent>
        {isLoading ? (
          <Skeleton
            width="100%"
            height="56px"
          />
        ) : (
          <Fragment>
            <Box mb="12px">
              <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
                Đối tượng:
              </Typography>
              <Typography>N/A</Typography>
            </Box>
            <Box mb="12px">
              <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
                Tên nhân viên kinh doanh:
              </Typography>
              <Typography>N/A</Typography>
            </Box>
            <Box mb="12px">
              <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
                Tên khách hàng:
              </Typography>
              <Typography>N/A</Typography>
            </Box>
            <Box mb="12px">
              <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
                Số tiền cần thanh toán theo {inventDetail?.data?.code}:
              </Typography>
              <Typography>đ{convertIntMoney(inventDetail?.data?.total)}</Typography>
              <Typography sx={{ fontStyle: "italic" }}>
                {convertCurrency(inventDetail?.data?.total)} đồng
              </Typography>
            </Box>
            <Box mb="12px">
              <Typography sx={{ color: "var(--main-grey)", fontWeight: "bold" }}>
                Số dư chưa gạt nợ:
              </Typography>
              <Typography>đ{convertIntMoney(inventDetail?.data?.total)}</Typography>
              <Typography sx={{ fontStyle: "italic" }}>
                {convertCurrency(inventDetail?.data?.total)} đồng
              </Typography>
            </Box>
            <Box mb="12px">
              <Typography
                sx={{ color: "var(--main-grey)", mb: "6px", fontWeight: "bold" }}
              >
                Nhập ngày sales post quỹ nhiệm chi:
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  sx={{ width: "100%" }}
                  onChange={(e) => setDebtDetail({ ...debtDetail })}
                />
              </LocalizationProvider>
            </Box>
            <Box mb="12px">
              <Typography
                sx={{ color: "var(--main-grey)", mb: "6px", fontWeight: "bold" }}
              >
                Nhập số tiền thanh toán:
              </Typography>
              <TextField
                fullWidth
                placeholder="Đơn vị đồng..."
              />
            </Box>
            <Box mb="12px">
              <Typography
                sx={{ color: "var(--main-grey)", mb: "6px", fontWeight: "bold" }}
              >
                Ghi chú:
              </Typography>
              <TextField
                multiline
                rows={4}
                fullWidth
                placeholder="Đơn vị đồng..."
              />
            </Box>
          </Fragment>
        )}
      </DialogContent>
      <DialogActions sx={{ p: "0 24px 24px" }}>
        <Button
          fullWidth
          variant="contained"
        >
          Xác nhận thanh toán
        </Button>
      </DialogActions>
    </Fragment>
  );
}
